import _ from "lodash";
import React, { useState } from "react";
import { Button, Card, Row, Table } from "react-bootstrap";
import verifyImport from "./api/verify";
import importResidents from "./api/importResidents";
import defaultColumns from "./defaultColumns";
import mapDefaultColumns from "./mapDefaultColumns";
import ImportHeader from "./renderHeader";
import ImportRow from "./renderRow";
import ImportModal from "./importModal";

const ImportTableView = ({ csvData, setImportFinished }) => {
  const [rows, setRows] = useState(mapDefaultColumns(csvData));
  const extraColumns = rows[0].length - defaultColumns.length;
  const extraArray = Array.from(
    { length: extraColumns > 0 ? extraColumns : 0 },
    (_, i) => {
      return {
        label: "Ignore",
        value: `Ignore${i}`,
      };
    }
  );
  const originalColumns = [...defaultColumns, ...extraArray];
  const [columns, setColumns] = useState(
    [...originalColumns].reduce((acc, column, index) => {
      acc[index] = column;
      return acc;
    }, {})
  );
  const [valid, setValid] = useState(false);
  const [errors, setErrors] = useState({});
  const [duplicates, setDuplicates] = useState({});
  const [loading, setLoading] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  return (
    <div className="card">
      <div className="card-header">
        <Row className="justify-content-between" style={{ marginLeft: 0 }}>
          <div>Imported client table</div>
          <Row style={{ marginRight: 4, marginLeft: 0 }}>
            <Button
              size="sm"
              onClick={async () => {
                setLoading(true);
                const [errors, duplicates] = await verifyImport(columns, rows);
                if (!errors || !errors.length) {
                  setValid(true);
                  setErrors({});
                } else {
                  setValid(false);
                }
                setErrors(errors);
                setDuplicates(duplicates);
                setLoading(false);
              }}
              disabled={loading}
            >
              Verify
            </Button>
            {valid && (
              <Button
                className="ml-2"
                size="sm"
                onClick={() => {
                  setShowImportModal(true);
                }}
                disabled={loading}
              >
                Import
              </Button>
            )}
          </Row>
        </Row>
      </div>
      <ImportModal
        show={showImportModal}
        closeModal={() => {
          setShowImportModal(false);
        }}
        importData={async () => {
          setShowImportModal(false);
          setLoading(true);
          await importResidents(columns, rows);
          setImportFinished(true);
        }}
      />
      {!_.isEmpty(errors) && (
        <div className="card text-white bg-danger">
          <div className="card-block">
            Some errors are present, please check the data and make sure
            everything is correct in order to continue.
            <ul>
              {Object.keys(errors).map((rowErrorKey) => {
                const rowErrors = errors[rowErrorKey];
                return (
                  <li>
                    Errors at line {parseInt(rowErrorKey) + 1}:
                    <ul>
                      {Object.keys(rowErrors).map((cellErrorsKey) => (
                        <li>
                          Error at column {parseInt(cellErrorsKey) + 1}:{" "}
                          {rowErrors[cellErrorsKey]}
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
      {!_.isEmpty(duplicates) && (
        <div
          className="card text-black"
          style={{
            borderRadius: 10,
            padding: 10,
            backgroundColor: "#FFFFE0",
          }}
        >
          <div className="card-block">
            Some duplicate residents are present, please check the data and make
            sure everything is correct.
          </div>
        </div>
      )}
      <div style={{ overflowX: "auto" }}>
        <Table className="table-responsive table-dark table-bordered table-sm">
          <ImportHeader
            options={originalColumns}
            columns={columns}
            changeColumn={(value, index, originalValue) => {
              const newColumns = { ...columns };
              if (value) {

                const replaceableIndex = Object.keys(columns).find(
                  (key) => columns[key].value === value.value
                );
                newColumns[replaceableIndex] = originalValue;
                newColumns[index] = value;
              } else {
                newColumns[index] = {
                  label: "Ignore",
                  value: `Ignore${extraArray.length + index}`,
                };
              }
              setColumns(newColumns);
            }}
          />
          <tbody>
            {rows.map((row, index) => (
              <ImportRow
                key={`${index}-row`}
                row={row}
                index={index}
                errors={errors[index]}
                duplicates={duplicates[index]}
                modifyValue={(value, cellIndex) => {
                  const newRow = [...row];
                  newRow[cellIndex] = value;
                  const newRows = [...rows];
                  newRows[index] = newRow;
                  setRows(newRows);
                }}
              />
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ImportTableView;
